export enum WalletName {
  UniSat = "UniSat",
  Xverse = "Xverse",
  Hiro = "Leather",
  Okx = "Okx",
}
